<template>
	<div class="navbar">
		<!-- 左侧品牌区域 -->
		<div class="navbar-brand">
			
			
		</div>

		<!-- 右侧用户区域 -->
		<div class="navbar-user">
			<div class="user-info">
				<span class="user-text">{{this.$storage.get('adminName')}}</span>
				<span class="user-role">{{this.$storage.get('role')}}</span>
			</div>
			
			<div class="logout-btn" @click="onLogout">
				<svg class="logout-icon" viewBox="0 0 24 24">
					<path d="M16,17V14H9V10H16V7L21,12L16,17M14,2A2,2 0 0,1 16,4V6H14V4H5V20H14V18H16V20A2,2 0 0,1 14,22H5A2,2 0 0,1 3,20V4A2,2 0 0,1 5,2H14Z"/>
				</svg>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				dialogVisible: false,
				ruleForm: {},
				user: {},
			};
		},
		created() {
			
		},
		mounted() {
			let sessionTable = this.$storage.get("sessionTable")
			this.$http({
				url: sessionTable + '/session',
				method: "get"
			}).then(({
				data
			}) => {
				if (data && data.code === 0) {
					this.user = data.data;
					this.$storage.set('userid',data.data.id);
				} else {
					let message = this.$message
					message.error(data.msg);
				}
			});
		},
		methods: {
			onLogout() {
				let storage = this.$storage
				let router = this.$router
				storage.clear()
				router.replace({
					name: "login"
				});
			},
			onIndexTap(){
				window.location.href = `${this.$base.indexUrl}`
			},
		}
	};
</script>


<style lang="scss" scoped>
	.navbar {
	display: flex;
	align-items: center;
	justify-content: space-between;
	height: 64px;
	padding: 0 32px;
	background: #ffffff;
	border-bottom: 1px solid #f1f5f9;
	position: relative;

	// 左侧品牌区域
	.navbar-brand {
		display: flex;
		align-items: center;
		gap: 12px;
		flex-shrink: 0;

		.brand-logo {
			width: 36px;
			height: 36px;
			background: #3b82f6;
			border-radius: 8px;
			display: flex;
			align-items: center;
			justify-content: center;

			.logo-icon {
				width: 20px;
				height: 20px;
				fill: white;
			}
		}

		.brand-info {
			.brand-title {
				font-size: 18px;
				font-weight: 600;
				color: #1e293b;
				margin: 0;
				line-height: 1;
				letter-spacing: -0.025em;
			}
		}
	}

	// 右侧用户区域
	.navbar-user {
		display: flex;
		align-items: center;
		gap: 16px;
		flex-shrink: 0;

		.user-info {
			display: flex;
			flex-direction: column;
			gap: 2px;
			text-align: right;

			.user-text {
				font-size: 14px;
				font-weight: 500;
				color: #1e293b;
				line-height: 1.2;
			}

			.user-role {
				font-size: 12px;
				color: #64748b;
				font-weight: 400;
				text-transform: capitalize;
			}
		}

		.logout-btn {
			width: 36px;
			height: 36px;
			background: #f8fafc;
			border: 1px solid #e2e8f0;
			border-radius: 8px;
			display: flex;
			align-items: center;
			justify-content: center;
			cursor: pointer;
			transition: all 0.2s ease;

			&:hover {
				background: #f1f5f9;
				border-color: #cbd5e1;
			}

			&:active {
				background: #e2e8f0;
			}

			.logout-icon {
				width: 16px;
				height: 16px;
				fill: #64748b;
			}
		}
	}
}

// 响应式设计
@media (max-width: 768px) {
	.navbar {
		height: 56px;
		padding: 0 20px;

		.navbar-brand {
			gap: 10px;

			.brand-logo {
				width: 32px;
				height: 32px;
				border-radius: 6px;

				.logo-icon {
					width: 18px;
					height: 18px;
				}
			}

			.brand-info {
				.brand-title {
					font-size: 16px;
				}
			}
		}

		.navbar-user {
			gap: 12px;

			.user-info {
				.user-text {
					font-size: 13px;
				}

				.user-role {
					font-size: 11px;
				}
			}

			.logout-btn {
				width: 32px;
				height: 32px;

				.logout-icon {
					width: 14px;
					height: 14px;
				}
			}
		}
	}
}

@media (max-width: 480px) {
	.navbar {
		height: 52px;
		padding: 0 16px;

		.navbar-brand {
			gap: 8px;

			.brand-logo {
				width: 28px;
				height: 28px;

				.logo-icon {
					width: 16px;
					height: 16px;
				}
			}

			.brand-info {
				.brand-title {
					font-size: 14px;
				}
			}
		}

		.navbar-user {
			gap: 8px;

			.user-info {
				display: none;
			}

			.logout-btn {
				width: 28px;
				height: 28px;

				.logout-icon {
					width: 12px;
					height: 12px;
				}
			}
		}
	}
	}
</style>
